export const CONTENT_REPORT_SOURCE = {
    USER: 'USER',
    DETECTION: 'DETECTION',
    BOARD_INVITE: 'BOARD_INVITE',
};

export const CONTENT_REPORT_STATUS = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    CONFIRMED: 'CONFIRMED',
};

export const CONTENT_REPORT_CLASSIFICATIONS = {
    OKAY: 'OKAY',
    SPAM: 'SPAM',
    PHISHING: 'PHISHING',
    PORN: 'PORN',
    ILLEGAL: 'ILLEGAL',
    INAPPROPRIATE: 'INAPPROPRIATE',
};

export const CONTENT_REPORT_CATEGORIES = {
    SPAM: 'SPAM',
    PHISHING: 'PHISHING',
    OTHER: 'OTHER',
};
